/**
 * Briques de navigation communes au détail d'une campagne et à la fiche
 * candidat : un onglet souligné (premier niveau) et un contrôle segmenté en
 * pilule (second niveau, visiblement secondaire pour ne pas se lire comme un
 * second rang d'onglets).
 *
 * Partagées pour que les deux écrans se lisent de la même façon : passer de la
 * campagne à la fiche d'un candidat ne doit pas changer la grammaire.
 */
import { cn } from "@repo/utils";

export function BoutonOnglet({
  actif,
  onClick,
  icone,
  children,
}: {
  actif: boolean;
  onClick: () => void;
  icone?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      aria-current={actif ? "page" : undefined}
      onClick={onClick}
      className={cn(
        "flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors",
        actif
          ? "border-primary text-primary"
          : "border-transparent text-muted-foreground hover:text-foreground",
      )}
    >
      {icone}
      {children}
    </button>
  );
}

export function ControleSegmente<T extends string>({
  libelle,
  options,
  valeur,
  onChoisir,
}: {
  /** Nom accessible du groupe. */
  libelle: string;
  options: readonly { valeur: T; libelle: string }[];
  valeur: T;
  onChoisir: (valeur: T) => void;
}) {
  return (
    <div
      role="group"
      aria-label={libelle}
      className="inline-flex self-start gap-0.5 rounded-full bg-muted p-1"
    >
      {options.map((option) => {
        const actif = option.valeur === valeur;
        return (
          <button
            key={option.valeur}
            type="button"
            aria-pressed={actif}
            onClick={() => onChoisir(option.valeur)}
            className={cn(
              "h-8 rounded-full px-4 text-sm font-medium transition-colors",
              actif
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground hover:bg-charte-hover",
            )}
          >
            {option.libelle}
          </button>
        );
      })}
    </div>
  );
}
